module.exports = __webpack_public_path__ + "img/shield-key.ff18fede.svg";